import { RECORDATION_CATEGORY_FIELD } from "./fields";
import { RECORDATION_CATEGORIES } from "./dropdowns";

export const DECISIONS_SEARCH_FOR_OPTION = 'Decisions';
export const FILINGS_SEARCH_FOR_OPTION = 'Filings';
export const DOCKETS_SEARCH_FOR_OPTION = 'Dockets (Including Service Lists)';
export const RECORDATIONS_SEARCH_FOR_OPTION = 'Recordations';
export const RECORDATION_PARTIES_SEARCH_FOR_OPTION = 'Recordation Parties';
export const RAIL_RECORDATIONS_SEARCH_FOR_OPTION = 'Rail Recordations';
export const WATER_RECORDATIONS_SEARCH_FOR_OPTION = 'Water Recordations';
export const BY_DATE_SEARCH_FOR_OPTION = 'By Date';
export const SERVICE_LIST_SEARCH_FOR_OPTION = 'Service List';
export const ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION = 'Environmental Comments';
export const ALL_DOCUMENTS_SEARCH_FOR_OPTION = 'Combined Filings/Decisions';

export const DECISION_DATA_TYPE = "decision";
export const FILING_DATA_TYPE = "filing";
export const DOCKET_DATA_TYPE = "docket";
export const RECORDATION_DATA_TYPE = "recordation";
export const SERVICE_LIST_DATA_TYPE = "serviceList";
export const ENVIRONMENTAL_COMMENTS_DATA_TYPE = "environmentalComment";
export const ALL_DOCUMENTS_DATA_TYPE = "document";

export const MAX_SEARCH_LIMIT = 6000;
export const SEARCH_RESULT_PAGE_SIZES = [50, 500, 1000];

export const SEARCH_FOR_OPTIONS = [
	DECISIONS_SEARCH_FOR_OPTION,
	FILINGS_SEARCH_FOR_OPTION,
	DOCKETS_SEARCH_FOR_OPTION,
	RECORDATIONS_SEARCH_FOR_OPTION,
	ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION,
	BY_DATE_SEARCH_FOR_OPTION
];

export const LOCKED_TO_OPTIONS = [
	DECISIONS_SEARCH_FOR_OPTION,
	FILINGS_SEARCH_FOR_OPTION,
	RECORDATIONS_SEARCH_FOR_OPTION,
	ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION
];

export const LOCKED_TO_NO_RETURN = [
	DECISIONS_SEARCH_FOR_OPTION,
	FILINGS_SEARCH_FOR_OPTION,
	RECORDATIONS_SEARCH_FOR_OPTION,
	ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION
];

export const BY_DATE_OPTIONS = [
	DECISIONS_SEARCH_FOR_OPTION,
	FILINGS_SEARCH_FOR_OPTION,
	RECORDATIONS_SEARCH_FOR_OPTION,
	ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION
]

export const BY_DATE_SEARCHES = [
	{
		searchFor: DECISIONS_SEARCH_FOR_OPTION,
		fields: null
	}, {
		searchFor: FILINGS_SEARCH_FOR_OPTION,
		fields: null
	}, {
		searchFor: RECORDATIONS_SEARCH_FOR_OPTION,
		fields: 
			{recordationCategory:RECORDATION_CATEGORIES[0].value}
		
	}, {
		searchFor: RECORDATIONS_SEARCH_FOR_OPTION,
		fields: 
			{recordationCategory:RECORDATION_CATEGORIES[1].value}
	}, {
		searchFor: ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION,
		fields: null
	}
];

export var SEARCH_FOR_ASSOCIATED_DATA_TYPE = {
	[DECISIONS_SEARCH_FOR_OPTION]: DECISION_DATA_TYPE,
	[FILINGS_SEARCH_FOR_OPTION]: FILING_DATA_TYPE,
	[DOCKETS_SEARCH_FOR_OPTION]: DOCKET_DATA_TYPE,
	[RECORDATIONS_SEARCH_FOR_OPTION]: RECORDATION_DATA_TYPE,
	[SERVICE_LIST_SEARCH_FOR_OPTION]: SERVICE_LIST_DATA_TYPE,
	[ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION]: ENVIRONMENTAL_COMMENTS_DATA_TYPE,
	[ALL_DOCUMENTS_SEARCH_FOR_OPTION]: ALL_DOCUMENTS_DATA_TYPE
}

export var SEARCH_FOR_ASSOCIATED_OPTION = {
	[DECISION_DATA_TYPE]: DECISIONS_SEARCH_FOR_OPTION,
	[FILING_DATA_TYPE]: FILINGS_SEARCH_FOR_OPTION,
	[DOCKET_DATA_TYPE]: DOCKETS_SEARCH_FOR_OPTION,
	[RECORDATION_DATA_TYPE]: RECORDATIONS_SEARCH_FOR_OPTION,
	[SERVICE_LIST_DATA_TYPE]: SERVICE_LIST_SEARCH_FOR_OPTION,
	[ENVIRONMENTAL_COMMENTS_DATA_TYPE]: ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION,
	[ALL_DOCUMENTS_DATA_TYPE]: ALL_DOCUMENTS_SEARCH_FOR_OPTION
}

export const getValidQueryParamFields = searchFor => {
	var queryParams = [];
	switch(searchFor){
		case RECORDATIONS_SEARCH_FOR_OPTION:
			queryParams.push(RECORDATION_CATEGORY_FIELD);
			break;
		default:
	}
	return queryParams;
};

export const isValidQueryParam = (fieldName, paramValue) => {
	var valid = false;
	switch(fieldName){
		case RECORDATION_CATEGORY_FIELD:
			for(let i in RECORDATION_CATEGORIES){
				if(paramValue === RECORDATION_CATEGORIES[i].value){
					valid = true;
				}
			}
			break;
		default:
	}
	return valid;
}
